export function normalizeLinkHref(linkHref: string | null | undefined): string {
  if (!linkHref) return '#';
  return linkHref.startsWith('http') || linkHref.startsWith('#') ? linkHref : `/${linkHref}`;
}
